<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-container>
        <div class="invoice-add">
          <b-card>
            <div slot="header">Generate New Invoice</div>

            <b-row class="my-2">
              <b-col cols="6">
                <b-form-group  label="Select Agent">
                  <treeselect v-model="form.agent" :multiple="false" :options="select2Agents" placeholder="Select Agent"/>
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <v-text-field
                  :v="$v.form['receipt_id']"
                  @blur="$v.form['receipt_id'].$touch()"
                  @focus="$v.form['receipt_id'].$reset()"
                  v-model="form.receipt_id"
                  type="number" name="receipt_id">
                  <span slot="label">Receipt Number</span>
                </v-text-field>
              </b-col>
            </b-row>

            <b-row class="my-2">
              <b-col cols="6">
                <v-input-date
                  :v="$v.form['from']"
                  @blur="$v.form['from'].$touch()"
                  @focus="$v.form['from'].$reset()"
                  v-model="form.from"
                  startOf="true"
                  label="From"></v-input-date>
              </b-col>
              <b-col cols="6">
                <v-input-date
                  :min="form.from"
                  :v="$v.form['to']"
                  @blur="$v.form['to'].$touch()"
                  @focus="$v.form['to'].$reset()"
                  v-model="form.to"
                  endOf="true"
                  label="To"></v-input-date>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="6">
                <v-input-date
                  v-model="form.invoiced_at"
                  label="Invoiced At"
                  :required="true"
                  :v="$v.form['invoiced_at']"
                  @blur="$v.form['invoiced_at'].$touch()"
                  @focus="$v.form['invoiced_at'].$reset()"></v-input-date>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <div class="h6 my-2">Additional Notes</div>
                <quill-editor id="InvoiceEdit-quill-editor" v-model="form.free_text"></quill-editor>
              </b-col>
            </b-row>

          </b-card>
          <b-row class="my-2">
            <b-col class="text-right">
              <b-button type="generate" variant="success" @click="generate">
                <i class="fa fa-dot-circle-o"></i> Generate Invoice
              </b-button>
              <b-button type="reset" variant="danger" to="/bookings">
                <i class="fa fa-ban"></i> Cancel
              </b-button>
            </b-col>
          </b-row>
        </div>
      </b-container>
    </div>
  </div>
</template>

<script>
import {baseURL} from '../../axios'
import {invoiceServices} from '../../services'
import {mapGetters} from 'vuex'
import moment from 'moment'
import {required, numeric} from 'vuelidate/lib/validators'
import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default {
  components: {
    Treeselect
  },
  data() {
    return {
      isBusy: false,
      invoiceId: '4',
      form: {
        agent: null,
        from: null,
        to: null,
        receipt_id: null,
        free_text: '',
        invoiced_at: null
      }
    }
  },
  computed: {
    ...mapGetters(
      'agents',
      [
        'select2Agents'
      ]
    ),
    ...mapGetters(
      'user',
      [
        'accessToken'
      ]
    ),
    invoiceUrl() {
      if (this.invoiceId) {
        return baseURL + 'invoice/' + this.invoiceId + '/print?token=' + this.accessToken
      } else {
        return null
      }
    }
  },
  methods: {
    checkForm() {
      let valid = !this.$v.$invalid
      if (!valid) {
        this.$v.$touch()
      } else {
        this.$v.$reset()
      }
      return valid
    },
    generate() {
      let payload = {
        ...this.form
      }

      payload.from = moment(payload.from).format('YYYY-MM-DD')
      payload.to = moment(payload.to).format('YYYY-MM-DD')

      let xhr = invoiceServices.generate(payload)

      xhr.then(
        this.generateSuccess
      ).catch(
        this.generateFail
      )

    },
    generateSuccess(res) {
      this.$store.dispatch('app/addSuccessLog', {
        origin: 'invoice/generate',
        message: 'Invoice generate!'
      })
      this.$router.push({ path: '/invoices/' + res.data.id })
    },
    generateFail(e) {
      this.$store.dispatch('app/addErrorLog', {
        origin: 'invoice/generate',
        ...e.response.data
      })
    }
  },
  created() {
    this.$store.dispatch('agents/index')
  },
  validations: {
    form: {
      agent: {
        required
      },
      invoiced_at: {
        required
      },
      receipt_id: {
        required,
        numeric
      },
      from: {
        required
      },
      to: {
        required
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/invoices/Add.vue